var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_2015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.317 119.976C55.4449 119.97 53.581 119.73 51.7689 119.263L51.4117 119.165L51.0804 119C39.1024 113.037 28.9972 105.16 21.0454 95.5882C14.463 87.6184 9.33109 78.5695 5.88039 68.8483C1.75388 57.2097 -0.231369 44.9291 0.0194006 32.5928C0.0244607 32.3338 0.0287431 32.1339 0.0287431 31.9961C0.0287431 25.9994 3.38088 20.7376 8.56868 18.5911C12.5392 16.9483 48.5894 2.24476 51.1941 1.18239C56.0995 -1.25832 61.3326 0.778834 62.1701 1.13508C64.0485 1.89771 97.3747 15.4331 104.576 18.8384C111.999 22.348 113.979 28.6529 113.979 31.825C113.979 46.186 111.474 59.6075 106.534 71.7168C102.545 81.5183 96.8905 90.5671 89.8176 98.4688C76.1713 113.718 62.5214 119.124 62.3897 119.172C60.7583 119.729 59.042 120.001 57.317 119.976ZM54.1069 112.08C55.2904 112.344 58.0149 112.739 59.7908 112.096C62.0468 111.279 73.4715 105.396 84.1476 93.4657C98.8983 76.9822 106.383 56.2611 106.394 31.8779C106.367 31.3839 106.014 27.8606 101.315 25.6389C94.2532 22.2995 59.6135 8.23452 59.2644 8.09276L59.1687 8.05248C58.4428 7.75041 56.1325 7.11414 54.54 7.94282L54.2212 8.09043C53.8351 8.24791 15.5674 23.8552 11.4861 25.5438C8.63115 26.7251 7.61393 29.6514 7.61393 31.9962C7.61393 32.1675 7.60946 32.4167 7.60316 32.7389C7.27698 49.4228 11.1649 90.4766 54.1069 112.08Z",
    fill: "#1C4E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7805 4.60643C52.7805 4.60643 14.165 20.3553 10.0276 22.0672C5.89026 23.779 3.82158 27.8874 3.82158 31.9958C3.82158 36.1043 0.718554 89.7135 52.7805 115.633C52.7805 115.633 57.5056 116.932 61.0905 115.633C64.6755 114.335 110.187 92.4237 110.187 31.8247C110.187 31.8247 110.187 25.662 102.946 22.2384C95.7058 18.8147 60.6996 4.60643 60.6996 4.60643C60.6996 4.60643 56.4007 2.72341 52.7805 4.60643Z",
    fill: "#349DD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M56.9178 16.9316V100.946C56.9178 100.946 17.9575 82.3238 18.3023 33.3653L56.9178 16.9316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6765 78L32 62.0295L41.1165 56.4116L48.5393 63.9733L73.6147 43L82 49.2947L47.6765 78Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_2015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationSuccess);
export default __webpack_public_path__ + "static/media/verification-success.344722b062c0ff52fdd123bdc8115c94.svg";
export { ForwardRef as ReactComponent };